import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import {
  Button,
  Inline,
  Container,
  Subnav,
  ListItem,
} from 'chaoskit/src/components'
import { tealDarkBlue } from 'chaoskit/src/assets/styles/utility/gradient'
import { SubnavMenuItemStyles } from 'chaoskit/src/components/Subnav'

import BaseLayout from './BaseLayout'

import Hero, {
  HeroContent,
  HeroTitleWrapper,
  HeroTitle,
  HeroTitleSub,
} from '~partials/Hero'
import Icon from '~components/Icon'
import Link from '~components/Link'
import Particles from '~components/Particles'

const Press = ({ children }) => {
  const theme = useTheme()

  return (
    <BaseLayout>
      <Hero compact css={{ ...tealDarkBlue(theme) }}>
        <Particles />
        <HeroContent>
          <Container>
            <HeroTitleWrapper>
              <HeroTitle>About Gremlin</HeroTitle>
              <HeroTitleSub>
                <p>News, company info, and media resources</p>
              </HeroTitleSub>

              <Button
                url="mailto:adam@10kmedia.co"
                type="default"
                css={{ marginTop: theme.space.large }}
              >
                <Icon icon="email" css={{ marginRight: theme.space.small }} />
                adam@10kmedia.co
              </Button>
            </HeroTitleWrapper>
          </Container>
        </HeroContent>
      </Hero>
      <Subnav>
        <Inline wrap={false} size="large">
          <ListItem>
            <Link css={SubnavMenuItemStyles(theme)} to="/press/about/">
              About Us
            </Link>
          </ListItem>
          <ListItem>
            <Link css={SubnavMenuItemStyles(theme)} to="/press/media/">
              Media Coverage
            </Link>
          </ListItem>
          <ListItem>
            <Link css={SubnavMenuItemStyles(theme)} to="/press/kit/">
              Logos &amp; Press Kit
            </Link>
          </ListItem>
        </Inline>
      </Subnav>
      {children}
    </BaseLayout>
  )
}

Press.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Press
